import { GetterTree } from 'vuex/types'
import { RootState } from '~/store/store.types'
import { getResource } from '~/utils/store'
import { InvitesState, InviteResource } from './invites.types'

const getters: GetterTree<InvitesState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (inviteId: string) => {
      return getResource<InviteResource>(state, inviteId, rootGetters, ['guest_list'])
    }
  }
}

export default getters
